import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import './PageLayout.css';

/**
 * A layout component that provides a main content area with an optional sidebar
 * and top action menu
 * Using BEM naming convention for CSS classes
 */
const PageLayout = ({ 
  children, 
  sidebar,
  topActionMenu,
  breadcrumbItems,
  footer,
  className = '' 
}) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '';

  return (
    <>
      {!isHomePage && breadcrumbItems && (
        <div className="page-layout__breadcrumb">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      )}

      <div className={`page-layout ${sidebar ? 'page-layout--with-sidebar' : ''} ${className}`}>
        <div className="page-layout__main">
          
          {topActionMenu && (
            <div className="page-layout__top-actions">
              {topActionMenu}
            </div>
          )}
          {children}
          
          {footer && (
            <div className="page-layout__footer">
              {footer}
            </div>
          )}
        </div>
        
        {sidebar && (
          <div className="page-layout__sidebar">
            {sidebar}
          </div>
        )}
      </div>
    </>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  sidebar: PropTypes.node,
  topActionMenu: PropTypes.node,
  footer: PropTypes.node,
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string
    })
  ),
  className: PropTypes.string
};

export default PageLayout;